var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contact-section" }, [
    _c("p", { staticClass: "contact-section-header" }, [
      _vm._v(
        "\n    " + _vm._s(_vm.$t("tenancy.table.fireMarshalContacts")) + "\n  "
      ),
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "contacts-table" }, [
      _c("thead", [
        _c(
          "tr",
          { staticClass: "table-header-height" },
          _vm._l(_vm.headers, function (header, index) {
            return _c("th", { key: index, class: header.class }, [
              _vm._v("\n          " + _vm._s(header.name) + "\n        "),
            ])
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.contacts, function (item, index) {
          return _c(
            "tr",
            { key: index, staticClass: "table-body-row__height" },
            [
              _c("td", { staticClass: "number-column" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("isEmptyValue")(item.i18nRole)) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "number-column" }, [
                _vm.canAccessContact
                  ? _c("div", [
                      _c(
                        "a",
                        {
                          staticClass: "name-hyper-link",
                          on: {
                            click: function ($event) {
                              return _vm.navToContactDetail(item.id, false)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.fullName || item.name) +
                              "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.isEngineer
                        ? _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !!item.remarks,
                                expression: "!!item.remarks",
                              },
                            ],
                            staticClass: "remark-included-flag",
                          })
                        : _vm._e(),
                    ])
                  : _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(item.fullName || item.name) +
                          "\n          "
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "number-column" }, [
                _c("div", [_vm._v(" " + _vm._s(item.phone))]),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "number-column" }, [
                _c("div", [
                  _vm._v(
                    " " + _vm._s(_vm._f("isEmptyValue")(item.fEmailsDisplay))
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "number-column" }, [
                _c("div", [
                  _c("pre", [
                    _vm._v(_vm._s(_vm._f("isEmptyValue")(item.fRemarks))),
                  ]),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }